import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Modal } from "@mui/material";
import "../../../components/UI Component/Modal/commonModals.css";
import slugicon from "../../../assets/shareLink.svg";
import Loader from "../../UI Component/Loader/Loader";
import "./style/shareModal.css";

const ShareModal = ({
  show,
  handleClose,
  handleBack,
  yesClickHandler,
  disableShare,
}) => {
  return (
    <>
      {/* {showLoader ? <Loader /> : null} */}
      {show ? (
        <Modal
          open={show}
          onClose={handleClose}
        >
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="share_link_modal_body ">
              <div className=" text-center mb-3  ">
                <img src={slugicon} style={{ height: "70px", width: "72px" }} />
                <p className="my-2 share_link_tag">Share Link</p>
                <p className="text-break share_link_tag_text">
                  Are you sure you want to share the consultation link?
                </p>
              </div>
              <div  className="d-flex justify-content-center container text-center mb-3">
                <div className="row px-5 ">
                  <div className="col px-2 mb-sm-2 ">
                    <Button
                      className="btn btn-lg border-0 mb-md-2  border rounded-pill coupon-confirm-button"
                      style={{ backgroundColor: "#17BAE0", color: "#fff" }}
                      onClick={yesClickHandler}
                      disabled={disableShare}
                    >
                      Yes
                    </Button>
                  </div>
                  <div className="col px-2  ">
                    <Button
                      className="btn btn-lg border   rounded-pill coupon-confirm-button"
                      style={{ backgroundColor: "#fff", color: "#17BAE0" }}
                      onClick={handleClose}
                    >
                      No
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default ShareModal;
